import cn from 'classnames';
import { forwardRef } from 'react';
import type { ButtonHTMLAttributes } from 'react';
import styles from './slot-button.module.css';

type Properties = ButtonHTMLAttributes<HTMLButtonElement>;

const SlotButton = forwardRef<HTMLButtonElement, Properties>(({ className, tabIndex = -1, ...rest }, reference) => (
  <button
    className={cn(styles['slot-button'], className)}
    ref={reference}
    tabIndex={tabIndex}
    type="button"
    {...rest}
  />
));

export default SlotButton;
